// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useState,
// } from "react";

// import { THEMES } from "./themes";

// const ThemeContext = createContext(null);

// const DEFAULT_THEME = "default";

// function applyTheme(themeKey) {
//   const theme = THEMES[themeKey] || THEMES[DEFAULT_THEME];

//   const root = document.documentElement;

//   root.setAttribute("data-dashboard-theme", themeKey);

//   root.style.setProperty("--bg-primary", theme.bgPrimary);
//   root.style.setProperty("--bg-surface", theme.bgSurface);
//   root.style.setProperty("--bg-surface-elevated", theme.bgSurfaceElevated);
//   root.style.setProperty("--bg-input", theme.bgInput);

//   root.style.setProperty("--accent-primary", theme.accentPrimary);
//   root.style.setProperty("--accent-hover", theme.accentHover);
//   root.style.setProperty("--accent-glow", theme.accentGlow);

//   root.style.setProperty("--text-main", theme.textMain);
//   root.style.setProperty("--text-sub", theme.textSub);
//   root.style.setProperty("--text-muted", theme.textMuted);

//   root.style.setProperty("--border-color", theme.borderColor);
//   root.style.setProperty("--border-focus", theme.borderFocus);

//   root.style.setProperty("--header-bg", theme.headerBg);
//   root.style.setProperty("--sidebar-bg", theme.sidebarBg);
//   root.style.setProperty("--sidebar-active", theme.sidebarActive);

//   root.style.setProperty("--card-bg", theme.cardBg);
//   root.style.setProperty("--input-bg", theme.inputBg);

//   root.style.setProperty(
//     "--theme-is-dark",
//     theme.isDark ? "1" : "0"
//   );
// }

// export function ThemeProvider({ children }) {
//   const [themeName, setThemeName] = useState(() => {
//     return localStorage.getItem("dashboard_theme") || DEFAULT_THEME;
//   });

//   useEffect(() => {
//     applyTheme(themeName);
//   }, [themeName]);

//   const changeTheme = (name) => {
//     if (!THEMES[name]) return;

//     setThemeName(name);

//     // Immediate browser persistence.
//     localStorage.setItem("dashboard_theme", name);

//     applyTheme(name);
//   };

//   const resetTheme = () => {
//     changeTheme(DEFAULT_THEME);
//   };

//   return (
//     <ThemeContext.Provider
//       value={{
//         themeName,
//         theme: THEMES[themeName] || THEMES[DEFAULT_THEME],
//         changeTheme,
//         resetTheme,
//       }}
//     >
//       {children}
//     </ThemeContext.Provider>
//   );
// }

// export function useTheme() {
//   const context = useContext(ThemeContext);

//   if (!context) {
//     throw new Error(
//       "useTheme must be used inside ThemeProvider"
//     );
//   }

//   return context;
// }  

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import { THEMES } from "./themes";

import {
  getAppearance,
} from "../services/appearanceService";


const ThemeContext = createContext(null);

const DEFAULT_THEME = "default";


function applyTheme(themeKey) {
  const theme =
    THEMES[themeKey] ||
    THEMES[DEFAULT_THEME];

  const root =
    document.documentElement;

  root.setAttribute(
    "data-dashboard-theme",
    themeKey
  );

  root.style.setProperty(
    "--bg-primary",
    theme.bgPrimary
  );

  root.style.setProperty(
    "--bg-surface",
    theme.bgSurface
  );

  root.style.setProperty(
    "--bg-surface-elevated",
    theme.bgSurfaceElevated
  );

  root.style.setProperty(
    "--bg-input",
    theme.bgInput
  );

  root.style.setProperty(
    "--accent-primary",
    theme.accentPrimary
  );

  root.style.setProperty(
    "--accent-hover",
    theme.accentHover
  );

  root.style.setProperty(
    "--accent-glow",
    theme.accentGlow
  );

  root.style.setProperty(
    "--text-main",
    theme.textMain
  );

  root.style.setProperty(
    "--text-sub",
    theme.textSub
  );

  root.style.setProperty(
    "--text-muted",
    theme.textMuted
  );

  root.style.setProperty(
    "--border-color",
    theme.borderColor
  );

  root.style.setProperty(
    "--border-focus",
    theme.borderFocus
  );

  root.style.setProperty(
    "--header-bg",
    theme.headerBg
  );

  root.style.setProperty(
    "--sidebar-bg",
    theme.sidebarBg
  );

  root.style.setProperty(
    "--sidebar-active",
    theme.sidebarActive
  );

  root.style.setProperty(
    "--card-bg",
    theme.cardBg
  );

  root.style.setProperty(
    "--input-bg",
    theme.inputBg
  );

  root.style.setProperty(
    "--theme-is-dark",
    theme.isDark ? "1" : "0"
  );
}


// =========================================================
// GET STORED USER
// =========================================================

function getStoredUser() {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  if (!storedUser) {
    return null;
  }

  try {
    return JSON.parse(storedUser);
  } catch {
    return null;
  }
}


// =========================================================
// LOAD THEME FROM BACKEND
// =========================================================

async function loadBackendTheme(
  setThemeName
) {
  const user =
    getStoredUser();

  if (!user?.id) {
    return;
  }

  try {
    const response =
      await getAppearance();

    const backendTheme =
      response?.theme_key ||
      DEFAULT_THEME;

    const safeTheme =
      THEMES[backendTheme]
        ? backendTheme
        : DEFAULT_THEME;

    setThemeName(
      safeTheme
    );

    /*
     * Keep localStorage as a cache/fallback.
     * Backend remains the source of truth.
     */
    localStorage.setItem(
      "dashboard_theme",
      safeTheme
    );

  } catch (error) {

    console.error(
      "Failed to load appearance from backend:",
      error
    );

    /*
     * If backend is unavailable,
     * existing localStorage theme continues
     * to work.
     */
  }
}


// =========================================================
// PROVIDER
// =========================================================

export function ThemeProvider({
  children,
}) {

  const [themeName, setThemeName] =
    useState(() => {

      return (
        localStorage.getItem(
          "dashboard_theme"
        ) ||
        DEFAULT_THEME
      );

    });


  // =======================================================
  // APPLY CURRENT THEME
  // =======================================================

  useEffect(() => {

    applyTheme(themeName);

  }, [themeName]);


  // =======================================================
  // LOAD BACKEND THEME
  // =======================================================

  useEffect(() => {

    loadBackendTheme(
      setThemeName
    );

  }, []);


  // =======================================================
  // RELOAD AFTER LOGIN
  // =======================================================

  useEffect(() => {

    const handleAuthChanged =
      () => {

        loadBackendTheme(
          setThemeName
        );

      };

    window.addEventListener(
      "appearance:auth-changed",
      handleAuthChanged
    );

    return () => {

      window.removeEventListener(
        "appearance:auth-changed",
        handleAuthChanged
      );

    };

  }, []);


  // =======================================================
  // CHANGE THEME
  // =======================================================

  const changeTheme = (
    name
  ) => {

    if (!THEMES[name]) {
      return;
    }

    setThemeName(name);

    /*
     * Keep existing behavior:
     * theme changes immediately in the browser.
     */
    localStorage.setItem(
      "dashboard_theme",
      name
    );

    applyTheme(name);
  };


  // =======================================================
  // RESET THEME
  // =======================================================

  const resetTheme = () => {

    changeTheme(
      DEFAULT_THEME
    );

  };


  return (
    <ThemeContext.Provider
      value={{
        themeName,

        theme:
          THEMES[themeName] ||
          THEMES[DEFAULT_THEME],

        changeTheme,

        resetTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}


export function useTheme() {

  const context =
    useContext(
      ThemeContext
    );

  if (!context) {

    throw new Error(
      "useTheme must be used inside ThemeProvider"
    );

  }

  return context;
}